"use client";

import { createContext, useContext, useState, type ReactNode } from "react";
import { SurveyModal } from "./survey-modal";

const SurveyContext = createContext<{ openSurvey: () => void }>({
  openSurvey: () => {},
});

export const useSurvey = () => useContext(SurveyContext);

export function SurveyProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  return (
    <SurveyContext.Provider value={{ openSurvey: () => setOpen(true) }}>
      {children}
      <SurveyModal open={open} onOpenChange={setOpen} />
    </SurveyContext.Provider>
  );
}
